import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/pagination";

function EventDetailSlider() {
  var swiper;

  function initializeSwiper() {
    swiper = new Swiper(".js-event-detail-slider", {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: true,
      spaceBetween: 60,
      speed: 300,
      slidesPerView: 1,
      pagination: {
        el: ".js-event-detail-slider-pagination",
        clickable: true,
      },
      // キーボード操作
      keyboard: {
        enabled: true,
      },
    });
  }

  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }

  function handleResize() {
    var slideCount = $(".js-event-detail-slider").find(".swiper-slide").length;

    if (slideCount === 1) {
      destroySwiper();
      $(".js-event-detail-slider-control").hide();
    } else {
      if (!swiper) {
        initializeSwiper();
      }
    }
  }
  // 初回実行
  handleResize();

  //再生/停止ボタン
  $(".js-event-detail-slider-stop-button").on("click", function () {
    if ($(this).hasClass("is-pause")) {
      swiper.autoplay.start();
      $(this).removeClass("is-pause");
      $(this).text("停止する");
    } else {
      swiper.autoplay.stop();
      $(this).addClass("is-pause");
      $(this).text("再生する");
    }
  });
}

export { EventDetailSlider };
